import React from 'react';
import { Link as RouterLink, generatePath } from 'react-router-dom';
import { Tab as MuiTab, styled, tabClasses, TabProps } from '@mui/material';

const Tab = styled(MuiTab)(({ theme }) => ({
  minWidth: 'unset',
  padding: `${theme.spacing(2)} 0`,
  fontWeight: 400,
  [`&.${tabClasses.selected}`]: {
    fontWeight: 700,
  },
}));

type RouterTabProps<Path extends string> = Omit<TabProps, 'value' | 'component' | 'to'> & {
  path: Path;
};

export const RouterTab = <Path extends string>({ path, ...props }: RouterTabProps<Path>) => {
  const tabProps = {
    ...props,
    value: path,
    to: generatePath(path),
    component: RouterLink,
  };
  return <Tab {...tabProps} />;
};
